var Alabama = "Алабама";
var Alaska = "Аляска";
var Arizona = "Аризона";
var Arkansas = "Арканзас";
var California = "Калифорния";
var Colorado = "Колорадо";
var Connecticut = "Коннектикут";
var Delaware = "Делавэр";
var Florida = "Флорида";
var Georgia = "Джорджия";
var Hawaii = "Гавайи";
var Idaho = "Айдахо";
var Illinois = "Иллинойс";
var Indiana = "Индиана";
var Iowa = "Айова";
var Kansas = "Канзас";
var Kentucky = "Кентукки";
var Louisiana = "Луизиана";
var Maine = "Мэн";
var Maryland = "Мэриленд";
var Massachusetts = "Массачусетс";
var Michigan = "Мичиган";
var Minnesota = "Миннесота";
var Mississippi = "Миссисипи";
var Missouri = "Миссури";
var Montana = "Монтана";
var Nebraska = "Небраска";
var Nevada = "Невада";
var Ohio = "Огайо";
var Oklahoma = "Оклахома";
var Oregon = "Орегон";
var Pennsylvania = "Пенсильвания";
var Tennessee = "Теннесси";
var Texas = "Техас";
var Utah = "Юта";
var Vermont = "Вермонт";
var Virginia = "Виргиния";
var Washington = "Вашингтон";
var Wisconsin = "Висконсин";
var Wyoming = "Вайоминг";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "Округ Колумбия (DC)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "Нью-Гэмпшир",
	"New Jersey": "Нью-Джерси",
	"New Mexico": "Нью-Мексико",
	"New York": "Нью-Йорк",
	"North Carolina": "Северная Каролина",
	"North Dakota": "Северная Дакота",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "Род-Айленд",
	"South Carolina": "Южная Каролина",
	"South Dakota": "Южная Дакота",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "Западная Виргиния",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
